import type { Colors } from '../../constants';
import { Typography } from './Typography';

export interface TextBadgeCompactProps {
  label: string;
  color?: Colors;
  uppercase?: boolean;
  ellipsis?: boolean;
}

export const TextBadgeCompact = ({
  label,
  color = 'text-ds-natural',
  uppercase,
  ellipsis,
}: TextBadgeCompactProps) => (
  <Typography
    uppercase={uppercase}
    color={color}
    ellipsis={ellipsis}
    label={label}
    tagName="span"
    fontSize="text-ds-50"
    lineHeight="leading-ds-50"
    fontWeight="font-ds-medium"
    letterSpacing="tracking-ds-wide"
  />
);
